module.exports = __webpack_public_path__ + "static/img/background.1c7208ae.svg";